export const getUrlParameter = (key?: string): any => {
  if (typeof window === "undefined") return;
  let urlParams = new URLSearchParams(window.location.search.toLowerCase());
  let entries = urlParams.entries();
  let paramsObj: Record<string, string> = {};

  for (const entry of entries) {
    paramsObj[entry[0]] = entry[1];
  }

  if (typeof key === "string") {
    return paramsObj[key.toLowerCase()];
  } else {
    return paramsObj;
  }
};

export const getHrefUrlParameter = (key?: string): any => {
  if (typeof window === "undefined") return;
  let urlParams = new URLSearchParams(window.location.href.split("?")[1]);
  let entries = urlParams.entries();
  let paramsObj: Record<string, string> = {};

  for (const entry of entries) {
    paramsObj[entry[0]] = entry[1];
  }

  if (typeof key === "string") {
    return paramsObj[key.toLowerCase()];
  } else {
    return paramsObj;
  }
};

export const createUrlParameter = (dataParams: Record<string, string>) => {
  return Object.entries(dataParams)
    .filter(([key, value]) => !!value)
    .map(([key, value]) => `${key}=${value}`)
    .join("&");
};

export const getUrlId = (string?: string) => {
  let pathname = string
    ? string.split("/")
    : window.location.pathname.split("/");
  return pathname[pathname.length - 1];
};
